import type { ShopifyVariant } from "../../api/types";

/** "Roses — Large", or just "Roses" for a product with one size. */
export function shopifyVariantLabel(
  variant: Pick<ShopifyVariant, "productTitle" | "variantTitle">,
): string {
  return variant.variantTitle
    ? `${variant.productTitle} — ${variant.variantTitle}`
    : variant.productTitle;
}
